export default [
	'd501', 'd502', 'd503', 'd504', 'd506', 'd507', 'd508',
	'd601', 'd602', 'd603', 'd604', 'd606', 'd607', 'd608',
	'd701', 'd702', 'd703', 'd704', 'd706', 'd707', 'd708',
	'd801', 'd802', 'd803', 'd804', 'd806', 'd807', 'd808',
];